/** Fund UI strings — keyed by Profile language names */
export const FUND_LANGUAGES = [
    'English', 'Español', 'Français', 'Deutsch', 'Português', 'العربية',
];

const en = {
    fundTitle: 'footballgirl fund',
    fundSubtitle: 'Direct crowdfunding for women\'s football projects globally.',
    startProject: 'Start a Campaign',
    myDrafts: 'My Drafts',
    searchPlaceholder: 'Search campaigns or creators…',
    all: 'All',
    daysLeft: 'days left',
    funded: 'funded',
    raised: 'raised',
    donate: 'Donate',
    backBrowse: '← Back to Browse',
    campaignLiveToast: 'Your campaign is live and accepting donations!',
    saved: 'Saved',
    preview: 'Preview',
    publish: 'Publish Campaign',
    saveDraft: 'Save as draft',
    stepBasics: 'Basics',
    stepStory: 'Story',
    stepPerks: 'Perks & FAQ',
    stepReview: 'Review & Launch',
    launchTitle: 'Launch a Campaign',
    launchSub: 'Raise funds for players, events, or football facilities.',
    aboutProject: 'About this project',
    updates: 'Updates',
    faq: 'FAQ',
    comments: 'Comments',
    rewards: 'Support Rewards',
    share: 'Share',
    copyLink: 'Copy link',
    shareX: 'Share on X',
    shareWhatsApp: 'WhatsApp',
    closed: 'Campaign closed',
    countdown: 'Time remaining',
    closeCampaign: 'Close campaign',
    previewBanner: 'Preview only — not yet live',
    noDonatePreview: 'Donations are disabled in preview mode.',
    feeTitle: 'Estimated payout breakdown',
    feeIfRaise: 'If you raise',
    feeStripe: 'Stripe processing (~2.9% + €0.30)',
    feePlatform: 'Platform fee (5%)',
    feeYouReceive: 'You receive approximately',
    emptyBrowse: 'No campaigns match your search.',
    draftsTitle: 'Draft campaigns',
    continueEdit: 'Continue editing',
    deleteDraft: 'Delete',
    confirmLive: 'Your project is live!',
    viewProject: 'View Campaign',
    hideName: 'Hide my name on the public supporter list',
    topUp: 'Add a little extra (optional)',
    postComment: 'Post comment',
    postUpdate: 'Post update',
    comingSoon: 'Coming soon page',
    notifyMe: 'Notify me when this launches',
    verifiedOnly: 'Verified creators only',
    selectReward: 'Select Reward',
    deliveryEst: 'Estimated delivery',
    noDelivery: 'No physical delivery',
    secretTier: 'Private tier link',
    connectTitle: 'Payout setup (Stripe Connect)',
    connectSub: 'Connect your bank via Stripe to receive donations directly (minus platform fee).',
    connectBtn: 'Connect with Stripe',
    connectResume: 'Continue Stripe setup',
    connectVerified: 'Payouts verified',
    connectPending: 'Setup incomplete',
    connectSignIn: 'Sign in to enable payouts before publishing.',
    publishRequiresStripe: 'Complete Stripe Connect to publish and accept donations.',
    verifiedCreator: 'Verified creator',
    donateRequiresStripe: 'This campaign is not yet accepting card payments.',
    goalLocked: 'Funding goal is locked after going live with verified payouts.',
    analyticsTitle: 'Campaign analytics',
    analyticsViews: 'Page views',
    analyticsClicks: 'Clicks by source',
    analyticsDonations: 'Donations by day',
    backerFeed: 'Backer activity (private)',
    utmTitle: 'Tracked share links',
    copyUtm: 'Copy',
    manageCampaign: 'Manage campaign',
    enableComingSoon: 'Enable Coming Soon page (share teaser before launch)',
    comingSoonTitle: 'Coming soon',
    comingSoonSub: 'Be the first to know when this campaign launches.',
    followerThanks: 'You\'re on the list — we\'ll email you at launch!',
    storyEditor: 'Creator story',
    tabStory: 'Story',
    tabUpdates: 'Updates',
    tabFaq: 'FAQ',
    tabComments: 'Comments',
    noUpdatesYet: 'No updates posted yet by the creator.',
    postUpdateTitle: 'Post a campaign update',
    updateTitleLabel: 'Update title',
    updateBodyLabel: 'Update body',
    updateImageLabel: 'Image URL (optional)',
    sendUpdate: 'Publish update',
    teamTitle: 'Team collaborators',
    inviteEmail: 'Collaborator email',
    roleEditor: 'Editor',
    roleViewer: 'Viewer (analytics only)',
    sendInvite: 'Send invite',
    revokeAccess: 'Revoke',
    shareReview: 'Share for review',
    shareReviewHint: 'Private link expires in 7 days. Regenerate anytime.',
    copyReviewLink: 'Copy review link',
    regenerateReview: 'Regenerate link',
    inviteAccepted: 'Collaborator invite accepted!',
    previewInvalid: 'This preview link is invalid or expired.',
    noCommentsYet: 'No community comments yet — start the conversation.',
    writeComment: 'Write a comment…',
    signInToComment: 'Sign in to join the discussion.',
    supporterMessages: 'Supporter messages',
    communityComments: 'Community',
    tierFulfilled: 'Fulfilled',
    tierDelivery: 'Estimated delivery',
    markFulfilled: 'Mark fulfilled',
    addPoll: 'Add a poll to this update',
    pollQuestion: 'Poll question',
    pollOptions: 'Options (one per line, 2–4)',
    votePoll: 'Vote',
    kycTitle: 'Identity verification',
    kycSub: 'Verify your identity with Stripe to earn a trusted badge on your campaigns.',
    kycVerified: 'Identity verified',
    kycPending: 'Not verified',
    kycBtn: 'Get verified',
    kycReturn: 'Checking verification status…',
    notifyOnComment: 'Email me when someone comments',
    tierFulfillment: 'Reward fulfillment',
    tierPrivate: 'Private tier (secret link only)',
    copySecretLink: 'Copy secret link',
    secretTierHint: 'Share this link with select backers — tier stays hidden on the public page.',
    noPollsYet: 'No polls on your updates yet.',
    pollResults: 'Poll results',
    topUpTotal: 'Voluntary top-ups',
    myCampaigns: 'My Fund campaigns',
    noMyCampaigns: 'You have not launched a Fund campaign yet.',
    statusLive: 'Live',
    statusDraft: 'Draft',
    privateTierUnlocked: 'Private reward unlocked via your link',
    galleryImage: 'Campaign image',
    help: {
        title: 'A clear headline helps supporters understand your goal in one glance.',
        category: 'Pick the category that best matches how funds will be used.',
        shortDesc: 'This appears on cards in the directory — keep it under 150 characters.',
        fullDesc: 'Tell your story: who benefits, what the money buys, and why it matters now.',
        target: 'Minimum €2,000. You keep what you raise — no all-or-nothing threshold.',
        endDate: 'Choose 7–90 days. When time ends, donations stop but the page stays visible.',
        rewardTiers: 'Optional perks for backers. Each tier needs a minimum pledge amount.',
        gallery: 'Add up to 8 image URLs (one per line or upload). First image is the hero.',
        video: 'Optional YouTube or Vimeo embed URL.',
        creator: 'Shown publicly so supporters know who is accountable.',
        email: 'Used for payout notifications and campaign updates — not shown publicly.',
        faq: 'Answer common questions before backers need to ask you.',
        publish: 'Publishing makes your campaign public. Goal locks after Stripe verification.',
        donate: 'Secure card payment. Platform fee supports footballgirl operations.',
        topUp: 'Optional extra support on top of your selected reward tier.',
        hideName: 'Your pledge still counts; only your display name is hidden.',
        search: 'Search by campaign title or creator name.',
        drafts: 'Unpublished campaigns auto-save every 15 seconds while you edit.',
        preview: 'See exactly how your page will look before going live.',
        closeCampaign: 'Ends fundraising early. The story page remains online.',
        connect: 'Standard Stripe Connect sends payouts to your bank. Required before publish.',
        comingSoon: 'Teaser page with email signup — hidden from the public directory until you publish.',
        analytics: 'Track views, UTM link clicks, and backer pledges for this campaign only.',
        storyEditor: 'Format your story with headings, lists, quotes, and inline images.',
        postUpdate: 'Backers who pledged will receive an email when you publish an update.',
        team: 'Editors can update the campaign and post updates. Viewers see analytics only.',
        shareReview: 'Share a read-only preview with advisors — not indexed in the directory.',
        poll: 'Optional poll — backers vote by email; results show after voting.',
        kyc: 'Stripe Identity checks government ID. Badge shows on live campaigns after approval.',
        tierDelivery: 'When backers can expect physical or digital rewards.',
        communityComments: 'Public discussion separate from donation messages.',
        secretTier: 'Private tiers are hidden unless backers use your secret URL.',
    },
};

const es = {
    ...en,
    fundSubtitle: 'Crowdfunding directo para proyectos de fútbol femenino en todo el mundo.',
    startProject: 'Iniciar campaña',
    myDrafts: 'Mis borradores',
    searchPlaceholder: 'Buscar campañas o creadoras…',
    donate: 'Donar',
    campaignLiveToast: '¡Tu campaña está activa y acepta donaciones!',
    publish: 'Publicar campaña',
    stepBasics: 'Básicos',
    stepStory: 'Historia',
    stepPerks: 'Recompensas y FAQ',
    stepReview: 'Revisión y lanzamiento',
    help: {
        ...en.help,
        title: 'Un título claro ayuda a entender tu objetivo de un vistazo.',
        target: 'Mínimo 2.000 €. Te quedas con lo recaudado — sin umbral todo o nada.',
    },
};

const fr = {
    ...en,
    fundSubtitle: 'Financement participatif pour le football féminin partout dans le monde.',
    startProject: 'Lancer une campagne',
    myDrafts: 'Mes brouillons',
    searchPlaceholder: 'Rechercher campagnes ou créatrices…',
    donate: 'Faire un don',
    campaignLiveToast: 'Votre campagne est en ligne et accepte les dons !',
    publish: 'Publier la campagne',
    stepBasics: 'Base',
    stepStory: 'Histoire',
    stepPerks: 'Récompenses et FAQ',
    stepReview: 'Revue et publication',
};

const de = {
    ...en,
    fundSubtitle: 'Direktes Crowdfunding für Frauenfußball-Projekte weltweit.',
    startProject: 'Kampagne starten',
    myDrafts: 'Meine Entwürfe',
    searchPlaceholder: 'Kampagnen oder Erstellerinnen suchen…',
    donate: 'Spenden',
    campaignLiveToast: 'Deine Kampagne ist live und nimmt Spenden an!',
    publish: 'Kampagne veröffentlichen',
};

const ar = {
    ...en,
    fundSubtitle: 'تمويل جماعي مباشر لمشاريع كرة القدم النسائية حول العالم.',
    startProject: 'ابدئي حملة',
    myDrafts: 'مسوداتي',
    searchPlaceholder: 'ابحث عن حملات أو منشئات…',
    donate: 'تبرع',
    campaignLiveToast: 'حملتك نشطة وتقبل التبرعات!',
    publish: 'نشر الحملة',
    backBrowse: '→ العودة للتصفح',
};

const pt = {
    ...en,
    fundSubtitle: 'Financiamento coletivo para projetos de futebol feminino no mundo.',
    startProject: 'Iniciar campanha',
    myDrafts: 'Meus rascunhos',
    donate: 'Doar',
    campaignLiveToast: 'Sua campanha está no ar e aceita doações!',
};

export const LANG_TO_LOCALE = {
    English: 'en',
    Español: 'es',
    Français: 'fr',
    Deutsch: 'de',
    Português: 'pt',
    'العربية': 'ar',
};

const PACKS = { en, es, fr, de, ar, pt };

export function resolveFundLang(profileLang) {
    const locale = LANG_TO_LOCALE[profileLang] || 'en';
    return { profileLang: profileLang || 'English', locale, rtl: locale === 'ar' };
}

export function t(locale, key) {
    const pack = PACKS[locale] || en;
    if (key.startsWith('help.')) {
        const hk = key.slice(5);
        return pack.help?.[hk] || en.help[hk] || '';
    }
    return pack[key] ?? en[key] ?? key;
}

export function getStoredFundLang() {
    try {
        return localStorage.getItem('fg_fund_lang') || 'English';
    } catch {
        return 'English';
    }
}

export function setStoredFundLang(lang) {
    localStorage.setItem('fg_fund_lang', lang);
}
